import {Injectable} from '@angular/core';
import {AbstractAdvTechService} from '../abstract-advtech.service';
import {Observable} from 'rxjs/Observable';
import {Response} from '@angular/http';

/**
 * Service for prism mobile bundle calls
 */
@Injectable()
export class AdvTechMobileService extends AbstractAdvTechService {
  /**
   * Prefix for the api calls (the symfony route)
   * @type {string}
   */
  protected prefix: string = 'core/googlecloud';
  /**
   * Gets the firebase config
   * @param {string} configName
   *
   * @returns {Observable<Response>}
   */
  getFirebaseConfig(configName: string): Observable<Response> {
    return this.callGetEndpoint('firebase/config/' + configName, true);
  }

  getFirebaseToken(configName: string): Observable<Response> {
    return this.callGetEndpoint('firebase/token/' + configName, true);
  }

  moveFile(moveFileRoute: string): Observable<Response> {
    moveFileRoute = moveFileRoute.replace('/' + this.prefix + '/', '');

    return this.callGetEndpoint(moveFileRoute, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/advtech/mobile/mobile.service.ts